import { useEffect, useState } from 'react'
import { getView, init } from './index'
import FeatureLayer from '@arcgis/core/layers/FeatureLayer'
import { PARCEL_SERVICE_URL } from '../parcels/constants'
import * as SelectionLayer from './layers/SelectionLayer'
import * as ComplexParcelDetailsLayer from './layers/ComplexParcelDetailsLayer'
import { useNavigate } from 'react-router-dom'



export const useViewScale = () => {
  const view = getView()
  const [scale, setScale] = useState<number>((view && view.scale) || 0)
  useEffect(() => {
    if (view) {
      view.watch("scale", (newScale: number, oldScale: number) => {
        setScale(newScale)
      })
    }
  }, [view])

  return scale
}

export const useCreateMap = (id: string) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setMapInitialized] = useState<boolean>(false)
  useEffect(() => {
    init(id)
    setMapInitialized(true)
  }, [id])
}

export const useInitMapOnClick = () => {
  const navigate = useNavigate()
  useEffect(() => {
    const enableMapClick = () => {                                                                                                                                  
      const view = getView()
      if (!view) {
        setTimeout(enableMapClick, 1000)
        return;
      }
      
      const parcelLayer = new FeatureLayer({
        url: PARCEL_SERVICE_URL,
      })

      view.on('click', (event) => {
        const isMapSelectable = SelectionLayer.getIsMapSelectable()
        if (parcelLayer === null || !isMapSelectable) return
        const screenPoint = {
          x: event.x,
          y: event.y
        }
        
        const query = parcelLayer.createQuery()
        query.geometry = view.toMap(screenPoint)
        query.distance = 1
        query.units = "meters"
        query.returnGeometry = true
        query.outFields = ["*"]

        parcelLayer.queryFeatures(query).then((response) => {
          const features: __esri.Graphic[] = response.features
          if (features.length > 0) {
            ComplexParcelDetailsLayer.clearGraphics()
            SelectionLayer.addClickedFeatures(features)
            navigate(`/pin/${features[0].attributes.PIN}`)
          }
        })
      })
    }
    enableMapClick()
  }, [navigate])
}